import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "react-emotion";
import { Button, Input, message } from "antd";
import axios from "axios";

import * as actions from "../../actions";
// ------------------------ Styles ------------
const CardWrapper = styled("div")({
  marginBottom: "30px"
});

const InputWrapper = styled("div")({
  width: "55%"
});
// ------------------------ Functions ------------

class WebsiteUrl extends Component {
  state = {
    loading: false
  };

  updateWebsiteUrl = url => {
    if (this.props.topic && url) {
      this.props.clearImages("stockImages");
      // this.props.clearCroppedImages();
      // this.props.clearCroppedLogos();
      this.props.clearPreviewImages();
      this.setState({ loading: true });
      axios
        .get(`${this.props.url}${url}`)
        .then(res => {
          if (res.data.length > 0) {
            this.props.addImages(res.data, "stockImages");
            this.setState({ loading: false });
          } else {
            message.error(`Sorry, we couldn't find any images for ${url}`);
            this.setState({ loading: false });
          }
        })
        .catch(e => {
          message.error(`Sorry, something went wrong`);
          this.setState({ loading: false });
        });
      return;
    }
    if (url) {
      url = !url.includes("http") ? `http://${url}` : url;
      this.props.clearImages("website");
      // this.props.clearCroppedImages();
      // this.props.clearCroppedLogos();
      this.props.clearPreviewImages();
      this.setState({ loading: true });
      axios
        .get(
          `https://us-central1-cogni-ga-health.cloudfunctions.net/url_resolver?url=${url}`
        )
        .then(res => {
          if (res.data.error) throw new Error();
          var xhr = new XMLHttpRequest();
          var newData = "";
          xhr.open("GET", `${this.props.url}?url=${res.data.url}`);
          xhr.seenBytes = 0;
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 3) {
              newData = xhr.response.substr(xhr.seenBytes);
              if (newData) {
                newData = JSON.parse(newData);
              }
              xhr.seenBytes = xhr.responseText.length;
              this.setState({ loading: false });
              this.props.addImages(newData, "website");
            } else if (xhr.readyState === 4 && newData === "") {
              message.error(`Sorry, we couldn't find any images for ${url}`);
              this.setState({ loading: false });
            }
          };
          xhr.addEventListener("error", () => {
            this.setState({ loading: false });
          });
          xhr.send();
        })
        .catch(e => {
          message.error(`Sorry, we couldn't find any images for ${url}`);
          this.setState({ loading: false });
        });
    }
  };

  renderLoadingButton = () => {
    return (
      <Button size="small" loading>
        Loading
      </Button>
    );
  };

  render() {
    const { Search } = Input;
    const { loading } = this.state;
    return (
      <CardWrapper>
        <InputWrapper>
          <Search
            suffix={<span />}
            placeholder={this.props.placeholder}
            onSearch={this.updateWebsiteUrl}
            enterButton={
              loading ? this.renderLoadingButton() : this.props.buttonTitle
            }
          />
        </InputWrapper>
      </CardWrapper>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.loadingInfo.loading
});

export default connect(
  mapStateToProps,
  actions
)(WebsiteUrl);
